"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jsonToStringify = jsonToStringify;
exports.jsonToEncode = jsonToEncode;
exports.versionCompare = versionCompare;

/**
 * @file 全民小视频 工具相关
 * @author zhangyanting <zhangyanting@baidu.com>
 */

/**
 * 对象转json串
 * @param {Object} jsonObject 对象
 * @return {String} json串
 */
function jsonToStringify(jsonObject) {
  return JSON.stringify(jsonObject);
}
/**
 * 对象转码
 * @param {Object} jsonObject 对象
 * @return {String} json串
 */


function jsonToEncode(jsonObject) {
  return encodeURIComponent(jsonToStringify(jsonObject));
}
/**
 * 版本比较
 * @param {String} version1 比较版本1
 * @param {String} version2 比较版本2
 * @return {Number} 比较结果
 */


function versionCompare(version1, version2) {
  var a = version1.toString().split('.');
  var b = version2.toString().split('.');
  var len = Math.max(a.length, b.length);

  for (var i = 0; i < len; i++) {
    if (a[i] && !b[i] && parseInt(a[i], 10) > 0 || parseInt(a[i], 10) > parseInt(b[i], 10)) {
      return 1;
    } else if (b[i] && !a[i] && parseInt(b[i], 10) > 0 || parseInt(a[i], 10) < parseInt(b[i], 10)) {
      return -1;
    }
  }

  return 0;
}